<template>
  <div data-sidebar="header" :class="cn('tw-flex tw-flex-col tw-gap-2 tw-p-2', props.class)">
    <slot />
  </div>
</template>

<script setup lang="ts">
import type { HTMLAttributes } from "vue"
import { cn } from "@/components/ui/utils"

const props = defineProps<{
  class?: HTMLAttributes["class"]
}>()
</script>
